// empty file prevent babel-plugin-import error
import '../../style/index.less'



// WEBPACK FOOTER //
// ./components/version/style/index.js